import { NgModule } from '@angular/core';
import { MessageCheckerComponent } from './message-checker.component';
import { TranslateModule } from '@ngx-translate/core';
import { ActionButtonModule } from '../action-button';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { PageModule } from '../page';

@NgModule({
  declarations: [MessageCheckerComponent],
  imports: [IntrackFeatureModule, TranslateModule.forChild(), ActionButtonModule, PageModule],
  exports: [MessageCheckerComponent],
})
export class MessageCheckerModule {}
